import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from 'react-feather';
import { Alert, Card, Col, Container, Row } from 'react-bootstrap';
import { Bar, Doughnut, Line, Pie, PolarArea, Radar } from 'react-chartjs-2';
import {
    bars,
    dynamicBars,
    line,
    line2,
    multiBars,
    pie,
    doughnut,
    polar,
    radar,
    verBars,
} from '../../variables/charts';

export default function Chart() {
    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>نمودار ها</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>داشبورد</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/chart'>نمودار ها</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Alert variant='tertiary'>
                    <Info className='mr-2' />
                    در این پروژه از{' '}
                    <Alert.Link href='https://chartjs.org/'>
                        {' '}
                        Chart.js{' '}
                    </Alert.Link>{' '}
                    استفاده شده. Chart.js یک کتابخانه سبک است که برای توسعه
                    دهندگان طراحی شده.
                </Alert>

                <div className='space-20' />

                <Row>
                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Bar data={bars} options={bars.options} />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Line data={line} options={line.options} />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <PolarArea
                                    data={polar}
                                    options={polar.options}
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Doughnut
                                    data={doughnut}
                                    options={doughnut.options}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Bar data={verBars} options={verBars.options} />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Line data={line2} options={line2.options} />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Pie data={pie} options={pie.options} />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Radar data={radar} options={radar.options} />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Bar
                                    data={dynamicBars()}
                                    options={dynamicBars().options}
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col sm={12} md={6} className='mb-4'>
                        <Card>
                            <Card.Body className='dashboard-charts'>
                                <Bar
                                    data={multiBars}
                                    options={multiBars.options}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
